import script from "./insurance-notice-word.vue?vue&type=script&lang=ts&setup=true"
export * from "./insurance-notice-word.vue?vue&type=script&lang=ts&setup=true"

import "./insurance-notice-word.vue?vue&type=style&index=0&id=9106e13a&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9106e13a"]])

export default __exports__